import { DicMajorFeaturePage } from "..";

/** 标准专业字典维护页面。 */
export function DicMajorPage() {
  return <DicMajorFeaturePage />;
}
